import ChatbotWrapper from './ChatbotWrapper.component';

export default ChatbotWrapper;